<template>
  <b-overlay
      :show="processing"
      rounded="sm"
  >

    <template v-slot:overlay>
      <div
          v-if="processing"
          class="text-center p-4 bg-primary text-light rounded"
      >
        <b-icon
            icon="cloud-download"
            font-scale="4"
        />
        <div class="mb-3 mt-2">
          منتظر بمانید ...
        </div>
        <b-progress
            min="1"
            max="60"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
        />
      </div>
    </template>

  <b-card
    title="مدیریت سفارش ها"
  >
    <b-row>
      <b-col
        class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="3">
                <b-form-group
                    label="گروه ورزشی"
                    label-for="ActivityGroupId"
                >
                  <z-activity-group v-model="filterOptions.ActivityGroupId" :multiple="true" :clearable="false" />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="بانک"
                  label-for="Bank"
                >
                  <v-select
                    v-model="filterOptions.Bank"
                    dir="rtl"
                    :reduce="x => x.value"
                    label="text"
                    :multiple="true"
                    :options="enums('bank')"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="کوپن"
                  label-for="CouponId"
                >
                  <z-coupon
                    v-model="filterOptions.CouponId"
                    :clearable="true"
                    :multiple="true"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group>
                  <label>پرداخت</label>
                  <v-select
                    v-model="filterOptions.IsPaid"
                    :reduce="x => x.value"
                    :options="enums('IsPaid')"
                    label="text"
                    dir="rtl"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="کد پیگیری" label-for="Code">
                  <b-form-input v-model="filterOptions.Code" />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="از تاریخ"
                  label-for="FromDate"
                >
                  <date-picker
                    v-model="filterOptions.FromDate"
                    type="datetime"
                    display-format="jYYYY/jMM/jDD HH:mm"
                    format="YYYY-MM-DD HH:mm"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="تا تاریخ"
                  label-for="FromDate"
                >
                  <date-picker
                    v-model="filterOptions.ToDate"
                    type="datetime"
                    display-format="jYYYY/jMM/jDD HH:mm"
                    format="YYYY-MM-DD HH:mm"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                    label="موبایل"
                    label-for="Mobile"
                >
                  <b-form-input
                      v-model="filterOptions.Mobile"
                      autocomplete="off"
                      type="number"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
              <b-button
                  variant="gradient-secondary"
                  class="mb-1 mr-1"
                  @click="exportExcel()"
              >خروجی اکسل
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :no-local-sorting="true"
          :sort-by="filterOptions.SortBy"
          :sort-desc="filterOptions.IsDesc"
          :busy="loading"
          @sort-changed="sortChange"
        >
          <template #cell(Id)="data">
            <b-link
              :to="{ name: 'updatediscount', params: { id: data.value }}"
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(ActivityGroup)="data">
            {{ data.value.Title }}
          </template>

          <template #cell(ActivityPackage)="data">
            {{ data.value.Title }}
          </template>

          <template #cell(ActivityPackageCourse)="data">
            {{ data.value.Title }}
          </template>

          <template #cell(Bank)="data">
            <span>{{ (enums('bank', 'value', data.value) || {}).text }}</span>
          </template>

          <template #cell(Coupon)="data">
            {{ data.value.Title }}
          </template>

          <template #cell(User)="data">
            <b-link :to="{ name: 'userDetail', params: { id: data.value.Id }}">
              <b-media
                vertical-align="center"
                style="align-items: center;"
              >
                <template #aside>
                  <b-avatar
                    :src="data.value.Image"
                  />
                </template>
                <span
                  class="font-weight-bold d-block text-nowrap"
                  style="color: #6e6b7b;"
                >
                  <template v-if="data.value.Name || data.value.Family">{{ data.value.Name }} {{ data.value.Family }}</template>
                  <template v-else>کاربر زیره</template>
                </span>
                <small class="text-muted">{{ data.value.Id }}</small>
              </b-media>
            </b-link>
          </template>

          <template #cell(IsPaid)="data">
            <b-badge
                v-if="data.item.IsPaid"
                variant="success"
            >
              پرداخت شده
            </b-badge>
            <b-badge
                v-else
                variant="warning"
                @click="showConfirmModal(data.item)"
            >
              پرداخت نشده
            </b-badge>
          </template>

          <template #cell(CreatedAt)="data">
            {{ data.value | date('date-time') }}
          </template>

          <template #cell(Price)="data">
            {{ data.value | price }}
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>
  </b-card>

    <b-modal
        v-model="isShowConfirm"
        v-if="isShowConfirm"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        modal-class="confirm-pay-modal"
        title="تایید پرداخت"
        :no-close-on-backdrop="true"
        size="sm"
        @ok="confirmPay"
    >
      <div>
        پرداخت مورد نظر تایید شود؟
      </div>
    </b-modal>
  </b-overlay>
</template>

<script>

import { BIcon, BIconCloudDownload } from 'bootstrap-vue'
import ZDietDuration from '@/tools/dietduration.vue'
import ZCoupon from '@/tools/coupon.vue'
import ZActivityPackage from '@/tools/activitypackage'
import ZActivityPackageCourse from '@/tools/activitypackagecourse'
import ZActivityGroup from "@/tools/activitygroup.vue";

export default {
  name: 'ActivityPackageOrder',
  components: {
    ZActivityGroup,
    ZActivityPackage,
    ZDietDuration,
    ZCoupon,
    ZActivityPackageCourse,
    BIcon,
    BIconCloudDownload
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      processing: false,
      counter: 1,
      isShowConfirm: false,
      filterOptions: {
        Title: null,
        Page: 1,
        SortBy: 'Id',
        IsDesc: true,
        IsPaid: null,
        ActivityGroupId: [],
        Bank: [],
        CouponId: [],
        Code: '',
        Mobile: null,
        FromDate: this.$moment().startOf('jMonth').format('YYYY-MM-DD HH:mm'),
        ToDate: this.$moment().endOf('jMonth').format('YYYY-MM-DD HH:mm')
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'ActivityGroup',
          label: 'گروه',
        },
        {
          key: 'ActivityPackage',
          label: 'برنامه',
        },
        {
          key: 'ActivityPackageCourse',
          label: 'دوره',
        },
        {
          key: 'User',
          label: 'کاربر',
        },
        {
          key: 'Code',
          label: 'کد پیگیری',
          tdClass: 'col-width-15',
        },
        {
          key: 'Price',
          label: 'مبلغ',
          sortable: true,
        },
        {
          key: 'Coupon',
          label: 'تخفیف',
        },
        {
          key: 'Bank',
          label: 'بانک',
        },
        {
          key: 'CreatedAt',
          label: 'تاریخ',
          sortable: true,
        },
        {
          key: 'IsPaid',
          label: 'پرداخت',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.update(1)
      }
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.activitypackageorder.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    remove(id) {
      this.removeRow(this.$api.discount.remove, 'Id', id)
    },
    showConfirmModal(row){
      this.row = row
      this.isShowConfirm = true
    },
    confirmPay(){
      this.isShowConfirm = false
      this.$http.post(
          this.$api.activitypackageorder.confirmpay, {
            Id: this.row.Id,
          },
      )
          .then(res => {
            this.update()
          })
    },
    exportExcel(){

      var This = this

      This.counter = 1
      This.processing = true

      let interval = setInterval(() => {
        This.counter += 1
      }, 1000)

      let filename = 'ActivityPackageOrder.xlsx'
      let xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.onreadystatechange = function() {
        if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {

          let remaining = 60 - This.counter

          let interval2 = setInterval(() => {
            This.counter += 1
          }, 100)

          setTimeout(() => {

            let a = document.createElement('a')
            a.href = window.URL.createObjectURL(xmlHttpRequest.response)
            a.download = filename
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            a.remove()

            clearInterval(interval)
            clearInterval(interval2)
            This.processing = false

          },remaining * 100)
        }
      }
      xmlHttpRequest.open("POST", '/api/activitypackageorder/export-excel')
      xmlHttpRequest.setRequestHeader('Content-Type', 'application/json')
      xmlHttpRequest.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('accessToken'))
      xmlHttpRequest.responseType = 'blob'
      xmlHttpRequest.send(JSON.stringify(this.filterOptions))
    },
  },
}
</script>
